// Every query value is a plain string, the format links in emails, Slack and
// bookmarks already use. TanStack's default JSON encoding would turn `?n=1`
// into a number and quote string values that look like JSON.
export type AppSearch = Partial<Record<string, string>>

export function parseAppSearch(searchStr: string): AppSearch {
	const search: AppSearch = {}
	// A repeated key keeps its first value, as URLSearchParams.get did.
	for (const [key, value] of new URLSearchParams(searchStr))
		search[key] ??= value
	return search
}

export function stringifyAppSearch(search: Record<string, unknown>): string {
	const params = new URLSearchParams()
	for (const [key, value] of Object.entries(search)) {
		if (value === undefined || value === null) continue
		params.set(key, String(value))
	}
	const query = params.toString()
	return query ? `?${query}` : ""
}

export function validateAppSearch(search: Record<string, unknown>): AppSearch {
	return search as AppSearch
}
